export default {
    orientation: {
        type: String,
        default: undefined
    }, 
    panes: {
        type: Array,
        default: undefined
    }, 

    // Events
    collapse: Function, 
    contentLoad: {
        type: Function,
        default: undefined
    },  
    error: Function, 
    expand: Function, 
    layoutChange: {
        type: Function,
        default: undefined
    },  
    resize: Function
}


// WEBPACK FOOTER //
// ./packages/kendo-layout-vue-wrapper/src/KendoSplitter/SplitterProps.js